import { render, staticRenderFns } from "./AlertMarkSafe.vue?vue&type=template&id=41ff06f2"
import script from "./AlertMarkSafe.vue?vue&type=script&lang=js"
export * from "./AlertMarkSafe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports